// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__QpQ4-","signatureBlock":"Footer_signatureBlock__348Bf","signature":"Footer_signature__3LfrN"};